var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2C7.34315 2 6 3.34315 6 5V10C6 11.6569 7.34315 13 9 13C10.6569 13 12 11.6569 12 10V5C12 3.34315 10.6569 2 9 2ZM10 18.9451V20.5C10 21.0523 9.55228 21.5 9 21.5C8.44772 21.5 8 21.0523 8 20.5V18.9451C3.50005 18.4476 0 14.6326 0 10C0 9.44772 0.447715 9 1 9C1.55228 9 2 9.44772 2 10C2 13.866 5.13401 17 9 17C12.866 17 16 13.866 16 10C16 9.44772 16.4477 9 17 9C17.5523 9 18 9.44772 18 10C18 14.6326 14.5 18.4476 10 18.9451ZM9 0C11.7614 0 14 2.23858 14 5V10C14 12.7614 11.7614 15 9 15C6.23858 15 4 12.7614 4 10V5C4 2.23858 6.23858 0 9 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicInactive);
export default __webpack_public_path__ + "static/media/mic_inactive.16dfbb0e1e48ca0290b90879d4b74e68.svg";
export { ForwardRef as ReactComponent };